import React, { forwardRef } from 'react';
import { TextInput, TextInputProps, Platform, StyleSheet } from 'react-native';
import { useTutor } from '../contexts/TutorContext';

interface InputFieldProps extends TextInputProps {
  value: string;
  onChangeText: (text: string) => void;
  onSubmitEditing: () => void;
  placeholder: string;
}

export const InputField = forwardRef<TextInput, InputFieldProps>((props, ref) => {
  const { selectedTutor } = useTutor();
  return (
    <TextInput
      {...props}
      ref={ref}
      style={[styles.input, props.style]}
      value={props.value}
      onChangeText={props.onChangeText}
      placeholder={props.placeholder}
      placeholderTextColor="#9e9e9e"
      onSubmitEditing={props.onSubmitEditing}
      returnKeyType="send"
      blurOnSubmit={false}
      editable={!!selectedTutor}
    />
  );
});

const styles = StyleSheet.create({
  input: {
    flex: 1,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 8,
    color: '#1a1a1a',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    marginRight: 8,
    fontSize: 14,
    outlineStyle: 'none',
    ...(Platform.OS === 'web' && {
      ':focus': {
        outlineStyle: 'none',
        borderColor: '#e0e0e0',
      },
      '::selection': {
        backgroundColor: '#e0e0e0',
      }
    }),
  },
});
